import { str } from "@lit/localize";
//#region src/generated/locales/en.ts
var templates = {
	"pd.chat.input.placeholder": `Write a message …`,
	"pd.chat.input.submit": `Send`,
	"pd.chat.item.srOther": str`${0}, ${1}:`,
	"pd.chat.item.srOwn": str`Me, ${0}:`,
	"pd.chat.list.empty": `No messages yet`,
	"pd.chat.list.label": `Message history`,
	"pd.chat.list.typing": `Writing a reply`,
	"pd.contact.address.title": `Address`,
	"pd.contact.check.company": `Company`,
	"pd.contact.check.private": `Private Individual`,
	"pd.contact.label.additional": `Address Additional Info`,
	"pd.contact.label.btw": `VAT ID`,
	"pd.contact.label.city": `City`,
	"pd.contact.label.company": `Company Name`,
	"pd.contact.label.email": `Email`,
	"pd.contact.label.firstName": `First Name`,
	"pd.contact.label.lastName": `Last Name`,
	"pd.contact.label.phone": `Phone`,
	"pd.contact.label.propertyDate": `Property date`,
	"pd.contact.label.street": `Street`,
	"pd.contact.label.streetNr": `No.`,
	"pd.contact.label.summary.propertyDate": str`Year of construction: ${0}`,
	"pd.contact.label.type": `Type`,
	"pd.contact.label.zip": `ZIP Code`,
	"pd.contact.property.year.selection": `Select year of construction`,
	"pd.form.field.invalid.url": `Enter a valid URL (e.g. example.com)`,
	"pd.history.changes.details": str`${0} Details`,
	"pd.history.changes.many": str`${0} changes`,
	"pd.history.changes.one": `1 change`,
	"pd.history.kind.created": `Created`,
	"pd.history.kind.deleted": `Deleted`,
	"pd.history.kind.process": `Process`,
	"pd.history.kind.restored": `Restored`,
	"pd.history.kind.updated": `Edited`,
	"pd.history.list.empty": `No entries yet`,
	"pd.history.list.loading": `Loading history`,
	"pd.history.value.empty": `empty`,
	"pd.mail.ccHint": `CC/BCC`,
	"pd.mail.details": `Details`,
	"pd.mail.list.empty": `No mails yet`,
	"pd.mail.list.loading": `Loading mails`,
	"pd.mail.meta.attempts": `Attempts`,
	"pd.mail.meta.endTime": `Completed`,
	"pd.mail.meta.error": `Error`,
	"pd.mail.meta.replyTo": `Reply to`,
	"pd.mail.meta.to": `Recipient`,
	"pd.mail.resend": `Resend`,
	"pd.mail.state.error": `Failed`,
	"pd.mail.state.pending": `Waiting`,
	"pd.mail.state.processing": `Sending`,
	"pd.mail.state.retry": `Retrying`,
	"pd.mail.state.success": `Sent`,
	"pd.mail.to": `to`,
	"pd.markdown.link.apply": `Apply`,
	"pd.markdown.link.cancel": `Cancel`,
	"pd.markdown.link.remove": `Remove`,
	"pd.markdown.link.text": `Display text`,
	"pd.markdown.link.url": `Link`,
	"pd.rating.input.cancel": `Cancel`,
	"pd.rating.input.errorText": `Please enter a text.`,
	"pd.rating.input.starsLabel": `Rating (optional)`,
	"pd.rating.input.submit": `Submit rating`,
	"pd.rating.input.text": `Review`,
	"pd.rating.item.showLess": `Show less`,
	"pd.rating.item.showMore": `Show more`,
	"pd.rating.item.source": `Source`,
	"pd.rating.list.create": `Write a review`,
	"pd.rating.list.empty": `No ratings yet`,
	"pd.rating.list.loading": `Loading ratings`,
	"pd.rating.overview.ariaAction": str`${0} — show list`,
	"pd.rating.overview.ariaRated": str`Rating: ${0} out of 5 stars, ${1}`,
	"pd.rating.overview.count": str`${0} ratings`,
	"pd.rating.overview.countMixed": str`${0} reports · ${1} with rating`,
	"pd.rating.overview.countOne": `1 rating`,
	"pd.rating.overview.empty": `No ratings yet`,
	"pd.rating.overview.loading": `Loading ratings`,
	"pd.rating.stars.label": str`Rating: ${0} out of 5 stars`,
	"pd.rating.stars.option": str`${0} out of 5 stars`,
	"pd.rating.stars.pickerLabel": `Select a rating`,
	"pd.trash.by": str`by ${0}`,
	"pd.trash.delete": str`Delete permanently (${0})`,
	"pd.trash.deleted": str`deleted ${0}`,
	"pd.trash.details": `Details`,
	"pd.trash.list.empty": `The trash is empty`,
	"pd.trash.list.loading": `Loading trash`,
	"pd.trash.marked-count": str`${0} marked`,
	"pd.trash.restore": str`Restore (${0})`,
	"pd.trash.row.mark": str`Mark ${0}`,
	"pd.trash.select-all": `Mark all`,
	"pd.socialmedia.aria.label": `Social-Media-Profile`,
	"pd.socialmedia.empty": `Keine Einträge`,
	"pd.socialmedia.new.entry": `Neuer Eintrag`,
	"pd.socialmedia.placeholder": `Socialmedia eingeben...`,
	"pd.socialmedia.delete": `Eintrag löschen`,
	"pd.socialmedia.cancel": `Abbrechen`,
	"pd.socialmedia.save": `Speichern`,
	"pd.contact.label.website": `Website`,
	"pd.iconPicker.selectIcon": `Icon auswählen`,
	"pd.iconPicker.clearIcon": `Icon entfernen`,
	"pd.iconPicker.placeholder": `Icon auswählen...`,
	"pd.iconPicker.dialogLabel": `Icon auswählen`,
	"pd.iconPicker.search": `Suchen...`,
	"pd.iconPicker.noResults": `Nichts gefunden`,
	"pd.iconPicker.noIcon": `Kein Icon`,
	"pd.iconPicker.recent": `Zuletzt verwendet`
};
//#endregion
export { templates };
